export default __webpack_public_path__ + "static/media/lmx.07e6e0f8.svg";